<script>
import ActionButton from './ActionButton.vue'
export default {
  extends: ActionButton,
  emits: ['next'],
  data() {
    return {
      direction: 'right',
      actionClass: 'btn-next',
    }
  },
  methods: {
    onClick() {
      this.$parent.$emit('next')
    },
  },
}
</script>
